<template>
  <svg class="sparkline-chart" :viewBox="`0 0 ${width} ${height}`">
    <path
      :d="pathData"
      fill="none"
      stroke="#495057"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- Dot on last data point -->
    <circle
      v-if="points.length > 0"
      :cx="points[points.length - 1].x"
      :cy="points[points.length - 1].y"
      r="2"
      fill="#0056b3"
    />
  </svg>
</template>

<script>
export default {
  name: 'Sparkline',
  props: {
    dataPoints: {
      type: Array,
      required: true,
      default: () => [],
    },
    width: {
      type: Number,
      default: 60,
    },
    height: {
      type: Number,
      default: 20,
    },
    padding: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    points() {
      if (this.dataPoints.length === 0) return [];

      const minX = this.padding;
      const maxX = this.width - this.padding;
      const minY = this.padding;
      const maxY = this.height - this.padding;

      const maxVal = Math.max(...this.dataPoints);
      const minVal = Math.min(...this.dataPoints);
      const valRange = maxVal - minVal || 1; // Avoid divide-by-zero

      return this.dataPoints.map((val, index) => {
        // Spread points horizontally
        const x = minX + (index / (this.dataPoints.length - 1)) * (maxX - minX);

        // Invert Y axis (as 0 is top of SVG viewbox)
        const y = maxY - ((val - minVal) / valRange) * (maxY - minY);
        return { x, y };
      });
    },
    pathData() {
      if (this.points.length === 0) return '';
      // Build SVG Path command (e.g. "M 2 10 L 30 5 L 58 12")
      return this.points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ');
    },
  },
};
</script>

<style scoped>
.sparkline-chart {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 20px;
}
</style>
